// import { Toast } from "vant";
import conditionMethod from "../../utils/conditionMethod";

//处理获取 hh-mm-ss 时间格式
const dateFilter_hh_mm_ss = date => {
  if (date) {
    let time = new Date(date);
    let h = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
    let m =
      time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
    let s =
      time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds();

    return `${h}:${m}:${s}`;
  } else {
    return "";
  }
};

//处理获取 YYYY年MM月DD日 时间格式
const dateFilter_YY_MM_DD = (date, type = 1) => {
  if (date) {
    let time = new Date(date);
    let y = time.getFullYear();
    let m =
      time.getMonth() + 1 < 10
        ? "0" + (time.getMonth() + 1)
        : time.getMonth() + 1;
    let d = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
    if (type === 1) {
      return `${y}年${m}月${d}日`;
    } else {
      return `${y}-${m}-${d}`;
    }
  } else {
    return "";
  }
};

//处理获取 星期X 时间格式
const dateFilter_w = date => {
  if (date) {
    let time = new Date(date);
    let w = time.getDay();
    let arr = ["一", "二", "三", "四", "五", "六", "日"];
    return `星期${arr[w - 1]}`;
  } else {
    return "";
  }
};

//处理获取 YYYY年MM月DD日 hh-mm-ss 时间格式
const dateFilter_YY_MM_DD_hh_mm_ss = date => {
  if (date) {
    return dateFilter_YY_MM_DD(date) + " " + dateFilter_hh_mm_ss(date);
  } else {
    return "";
  }
};

//处理获取 yyyy-MM-dd hh-mm-ss 时间格式
const dateFilter_yy_MM_dd_hh_mm_ss = date => {
  if (date) {
    return dateFilter_YY_MM_DD(date, 2) + " " + dateFilter_hh_mm_ss(date);
  } else {
    return "";
  }
};

//处理获取 持续时间(参数为进场时间与出场时间)
const durationFilter = (exitTime, enterTime) => {
  if (exitTime && enterTime) {
    let duration = new Date(exitTime).getTime() - new Date(enterTime).getTime();
    if (duration < 0) {
      return "---";
    }
    let str = "";
    let D = Math.floor(duration / 1000 / 3600 / 24);
    str = D > 0 ? str + D + "天" : str;
    let h = Math.floor((duration / 1000 / 3600) % 24);
    str = h > 0 ? str + h + "小时" : str;
    let m = Math.floor((duration / 1000 / 60) % 60);
    str = m > 0 ? str + m + "分钟" : str;
    return str;
  } else {
    return "";
  }
};

//处理获取 持续时间（参数为持续时间  单位为分钟）
const timeTransformation = duration => {
  if (duration) {
    if (duration < 0) {
      return "---";
    }
    let str = "";
    let D = Math.floor(duration / 3600 / 24);
    str = D > 0 ? str + D + "天" : str;
    let h = Math.floor((duration / 3600) % 24);
    str = h > 0 ? str + h + "小时" : str;
    let m = Math.floor((duration / 60) % 60);
    str = m > 0 ? str + m + "分钟" : str + "0分钟";

    return str;
  } else {
    return "";
  }
};

const leaveWayFilter = type => {
  if (type) {
    switch (type) {
      case 1:
        return "收费员办理离场";

      case 2:
        return "自助离场";

      case 3:
        return "地磁感应离场";

      default:
        return "未知";
    }
  } else {
    return "未知";
  }
};

const payWayFiler = type => {
  // Toast(type + "");
  return conditionMethod.payWayTest(type);
};

export default {
  dateFilter_hh_mm_ss,
  dateFilter_YY_MM_DD,
  dateFilter_w,
  dateFilter_YY_MM_DD_hh_mm_ss,
  dateFilter_yy_MM_dd_hh_mm_ss,
  durationFilter,
  timeTransformation,
  leaveWayFilter,
  payWayFiler
};
